import { Dictionary } from 'lodash';
import { groupBy } from './common';
import { IEntity } from '../components/UserDetails/AdditionalInfos/utils';

export const groupByEchelon = (
  entities: Partial<IEntity>[] | null,
): Dictionary<string | Partial<IEntity>[]>[] =>
  groupBy<Partial<IEntity>>(entities, (_) => _?.echelon?.name, [
    'name',
    'entities',
  ]);
